import React, { useEffect, useRef, useState } from "react";

function formatCount(value) {
  return new Intl.NumberFormat("en-IN").format(value);
}

export default function StatCounter({
  value,
  prefix = "",
  suffix = "",
  label,
  duration = 1400,
}) {
  const elementRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (typeof window === "undefined") {
      setIsVisible(true);
      return undefined;
    }

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setCount(value);
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.45 }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, [value]);

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    let frameId;
    const startTime = performance.now();

    const tick = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(value * eased));

      if (progress < 1) {
        frameId = window.requestAnimationFrame(tick);
      }
    };

    frameId = window.requestAnimationFrame(tick);

    return () => window.cancelAnimationFrame(frameId);
  }, [duration, isVisible, value]);

  return (
    <article ref={elementRef} className="stat-card">
      <div className="stat-value">
        <span>{prefix}</span>
        {formatCount(count)}
        <span>{suffix}</span>
      </div>
      <p>{label}</p>
    </article>
  );
}
